import { useRef } from 'react';
import { useResizeObserver } from './use-resize-observer';
const useDOMWidth = () => {
  const measureRef = useRef<HTMLSpanElement>(null);
  const contentRect = useResizeObserver<HTMLSpanElement>(measureRef);
  return {
    width: contentRect?.width ?? 0,
    measureRef
  };
};
export { useDOMWidth };